import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoDownArrowDark, LazySvgoDownArrowWhite, LazySvgoDownArrow, LazySvgoLogosGoogle, LazySvgoPreviewBackArrow, LazySvgoPreviewBackToSiteArrow, LazySvgoPreviewInstructionsIcon, LazySvgoPreviewPrintIcon } from '#components'
const lazyGlobalComponents = [
  ["SvgoDownArrowDark", LazySvgoDownArrowDark],
["SvgoDownArrowWhite", LazySvgoDownArrowWhite],
["SvgoDownArrow", LazySvgoDownArrow],
["SvgoLogosGoogle", LazySvgoLogosGoogle],
["SvgoPreviewBackArrow", LazySvgoPreviewBackArrow],
["SvgoPreviewBackToSiteArrow", LazySvgoPreviewBackToSiteArrow],
["SvgoPreviewInstructionsIcon", LazySvgoPreviewInstructionsIcon],
["SvgoPreviewPrintIcon", LazySvgoPreviewPrintIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
